import React from "react"
import stableSort from "../../../utils/Table/stableSort";
import getComparator from "../../../utils/Table/getComparator";
import { TableRow, TableBody, TableCell, Theme, createStyles, withStyles } from "@material-ui/core";
import classes from './index.module.css'

type Props = {
    order: 'asc' | 'desc'
    orderBy: string
    data: any[]
    celles: any[]
    action?: (row: any) => JSX.Element
}

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    body: {
      padding: '10px 10px',
      borderRadius: '0',
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
)(TableCell);


const SimpleTableBody  = ({order,orderBy, data, celles, action}:Props) => {
    return (
        <TableBody>
        {stableSort(data, getComparator(order, orderBy))
          .slice()
          .map((row: any, index: number) => {
            const labelId = `enhanced-table-checkbox-${index}`;

            return (
              <TableRow
                className={classes.hover}
                key={index}
                role="checkbox"
                tabIndex={-1}
              >
                {celles.map(cell => <StyledTableCell id={labelId} scope="row" align={cell.align ? cell.align :"left"}>
                  {cell.format ? cell.format(row) : row[cell.id]}
                </StyledTableCell>)}
                {action && <StyledTableCell align="right">{action(row)}</StyledTableCell>}
              </TableRow>
            );
          })}
      </TableBody>
    )
}

export default SimpleTableBody;